module.exports = __webpack_public_path__ + "static/media/banner-nao-logado-mobile-1.8da190fb.webp";